'use client';

import { useLayoutEffect } from 'react';
import { Card, InlineAuth } from '@instamenu/ui-system-next';
import { useUserContext } from '@instamenu/context-user';
import { useRouter } from 'next/navigation';
import { SignInStyles } from './SignIn.css';

export function SignIn() {
  const router = useRouter();
  const { isAuthenticated, requestedPath } = useUserContext();

  useLayoutEffect(() => {
    if (isAuthenticated) {
      router.push(requestedPath);
    }
  }, [isAuthenticated, requestedPath, router]);

  return (
    <Card className={SignInStyles} style={{ gap: 12 }}>
      <h1>Sign in</h1>
      <InlineAuth />
    </Card>
  );
}
